"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var icons_material_1 = require("@mui/icons-material");
var material_1 = require("@mui/material");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var ButtomComponent_1 = __importDefault(require("../../../components/Form/ButtomComponent"));
var InputSearch_1 = __importDefault(require("../../../components/InputSearch"));
var SectionTitle_1 = __importDefault(require("../../../components/SectionTitle"));
var TableComponent_1 = __importDefault(require("../../../components/TableComponent"));
var TablePaginationComponent_1 = __importDefault(require("../../../components/TablePaginationComponent"));
var constants_1 = require("../../../constants");
var ChipStatusContainer_1 = __importDefault(require("../../../containers/ChipStatusContainer"));
var DialogFilterListContainer_1 = __importDefault(require("../../../containers/DialogFilterListContainer"));
var HelperSearchOrFilterContainer_1 = __importDefault(require("../../../containers/HelperSearchOrFilterContainer"));
var ModalCreateCampaignContainer_1 = __importDefault(require("../../../containers/ModalCreateCampaignContainer"));
var hooks_1 = require("../../../hooks");
var useDisclosure_1 = __importDefault(require("../../../hooks/useDisclosure"));
var services_1 = require("../../../services");
var styles_1 = require("../../../styles");
var utilities_1 = require("../../../utilities");
var DrawerCampaignAdminDetailContainer_1 = __importStar(require("../../../containers/DrawerCampaignAdminDetailContainer"));
var useMutationDownloadTemplateForUploadClients_1 = require("../../../hooks/mutations/useMutationDownloadTemplateForUploadClients");
var CampaignList = function () {
    var _a, _b;
    var _c = (0, react_router_dom_1.useSearchParams)(), searchParams = _c[0], setSearchParams = _c[1];
    var navigate = (0, react_router_dom_1.useNavigate)();
    var disclosureCampaignDrawer = (0, useDisclosure_1.default)();
    var disclosureCreateCampaignModal = (0, useDisclosure_1.default)();
    var disclosureFilterDialog = (0, useDisclosure_1.default)();
    var headerContainer = (0, react_1.useRef)(null);
    var termSearch = searchParams.get('term');
    var initialFilterListValue = utilities_1.QueryParamsUtils.getQueryParamsMultipleInitialValues({
        initialParamValues: { 'status[]': [], merchant_id: [] },
        queryParams: searchParams,
    });
    var _d = (0, hooks_1.useFetchCampaignsAdmin)(), campaignsData = _d.data, isLoading = _d.isLoading, isFetching = _d.isFetching, refetch = _d.refetch;
    var _e = (0, hooks_1.useGlobalState)(constants_1.GET_DETAIL_CAMPAIGN), setCampaignDetail = _e[1];
    var handleShowDetail = function (item) {
        searchParams.set('campaignIdentifier', item.id);
        setSearchParams(searchParams);
        disclosureCampaignDrawer.onOpen();
        setCampaignDetail(item);
    };
    var handleCloseCampaignDrawer = function () {
        searchParams.delete('campaignIdentifier');
        setSearchParams(searchParams);
        disclosureCampaignDrawer.onClose();
    };
    var mutationDownloadTemplate = (0, useMutationDownloadTemplateForUploadClients_1.useMutationDownloadTemplateForUploadClients)();
    var getAllMerchant = (0, hooks_1.useFetchAllMerchants)();
    var merchantsApi = getAllMerchant.data
        ? getAllMerchant.data.map(function (merchant) { return ({
            filter: 'Identificador del Cliente B2B',
            key: 'merchant_id',
            value: merchant.company_name,
            dbKey: merchant.id,
        }); })
        : [];
    var filterList = __spreadArray(__spreadArray([], services_1.optionCampaignFilterList, true), merchantsApi, true);
    var handleShowClientCards = function (item) {
        var queryParams = {
            merchantIdentifier: item.merchant_id,
            campaignIdentifier: item.id,
        };
        navigate({
            pathname: '/admin/reports/client-cards',
            search: "?".concat((0, react_router_dom_1.createSearchParams)(queryParams)),
        });
    };
    return ((0, jsx_runtime_1.jsxs)(styles_1.WrapperPage, { children: [(0, jsx_runtime_1.jsxs)(material_1.Paper, __assign({ elevation: 0, sx: { marginBottom: '30px' }, ref: headerContainer }, { children: [(0, jsx_runtime_1.jsx)(SectionTitle_1.default, { title: "Campa\u00F1as", renderRight: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ButtomComponent_1.default, __assign({ variant: "contained", onClick: disclosureCreateCampaignModal.onOpen }, { children: "Nueva Campa\u00F1a" })), (0, jsx_runtime_1.jsx)(ButtomComponent_1.default, __assign({ variant: "contained", onClick: function () { return mutationDownloadTemplate.mutate(); } }, { children: "Descargar Plantilla" })), (0, jsx_runtime_1.jsx)(material_1.Tooltip, __assign({ title: "Refrescar lista" }, { children: (0, jsx_runtime_1.jsx)(ButtomComponent_1.default.Filter, __assign({ variant: "outlined", color: "inherit", onClick: function () { return refetch(); } }, { children: (0, jsx_runtime_1.jsx)(icons_material_1.Refresh, {}) })) }))] }) }), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: {
                            display: 'grid',
                            gap: '5px',
                            gridTemplateColumns: '1fr',
                        } }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ style: {
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    gap: '10px',
                                } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: {
                                            width: { xs: '100%', sm: '50%' },
                                        } }, { children: (0, jsx_runtime_1.jsx)(InputSearch_1.default, { placeholder: "Buscar campa\u00F1a" }) })), (0, jsx_runtime_1.jsxs)(ButtomComponent_1.default.Filter, __assign({ variant: "outlined", size: "large", color: "inherit", onClick: disclosureFilterDialog.onOpen }, { children: [(0, jsx_runtime_1.jsx)(material_1.Icon, { children: (0, jsx_runtime_1.jsx)(icons_material_1.ManageSearchOutlined, {}) }), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ component: "p", sx: {
                                                    display: { xs: 'none', sm: 'block' },
                                                    margin: { xs: '0', sm: '0 0 0 8px' },
                                                } }, { children: "Filtros" }))] })), (0, jsx_runtime_1.jsx)(DialogFilterListContainer_1.default, { open: disclosureFilterDialog.isOpen, onClose: disclosureFilterDialog.onClose, optionFilterList: filterList, filterList: initialFilterListValue, isLoading: getAllMerchant.isLoading || getAllMerchant.isFetching })] })), (0, jsx_runtime_1.jsx)(styles_1.HelperText, { children: "Buscar por: Nombre del Cliente B2B, Descripci\u00F3n." })] })), (0, jsx_runtime_1.jsx)(HelperSearchOrFilterContainer_1.default, { search: termSearch !== null && termSearch !== void 0 ? termSearch : '', filterList: initialFilterListValue })] })), (0, jsx_runtime_1.jsxs)(material_1.Paper, { children: [(0, jsx_runtime_1.jsx)(TableComponent_1.default, { variant: "normal", isLoading: isLoading || isFetching, rows: (_a = campaignsData === null || campaignsData === void 0 ? void 0 : campaignsData.data) !== null && _a !== void 0 ? _a : [], keyExtractor: function (item) { return item.id; }, stickyHeader: true, maxHeight: "calc(100vh - ".concat(headerContainer.current &&
                            ((_b = headerContainer.current) === null || _b === void 0 ? void 0 : _b.clientHeight) + 240, "px)"), columns: [
                            {
                                label: 'Cliente B2B',
                                field: 'company_name',
                                type: 'text',
                                valueGetter: function (_a) {
                                    var row = _a.row;
                                    return row.company_name;
                                },
                            },
                            {
                                label: 'Descripción',
                                field: 'description',
                                type: 'text',
                                valueGetter: function (_a) {
                                    var row = _a.row;
                                    return row.description;
                                },
                            },
                            {
                                label: 'Cantidad de Tarjetas',
                                field: 'cards_quantity',
                                align: 'right',
                                type: 'text',
                                valueGetter: function (_a) {
                                    var row = _a.row;
                                    return row.cards_quantity;
                                },
                            },
                            {
                                label: 'Monto a Recargar',
                                field: 'cards_amount',
                                align: 'right',
                                type: 'text',
                                valueGetter: function (_a) {
                                    var row = _a.row;
                                    return (0, utilities_1.amountFormatByCurrencyCode)({
                                        amount: Number(row.cards_amount),
                                        currency_code: row.cards_currency_code,
                                    });
                                },
                            },
                            {
                                label: 'Tarjetas Usadas',
                                field: 'cards_used',
                                align: 'right',
                                type: 'text',
                                valueGetter: function (_a) {
                                    var row = _a.row;
                                    return row.cards_used;
                                },
                            },
                            {
                                label: 'Estado',
                                field: 'status',
                                align: 'center',
                                type: 'text',
                                valueGetter: function (_a) {
                                    var row = _a.row;
                                    return ((0, jsx_runtime_1.jsx)(ChipStatusContainer_1.default, { status: row.status }));
                                },
                            },
                            {
                                label: 'Fecha de Registro',
                                field: 'created_at',
                                align: 'left',
                                type: 'text',
                                valueGetter: function (_a) {
                                    var row = _a.row;
                                    return (0, utilities_1.formatDate)({ date: row.created_at });
                                },
                            },
                            {
                                label: 'Fecha de Envío del Correo de Activación',
                                field: 'activation_email_send_date',
                                align: 'left',
                                type: 'text',
                                valueGetter: function (_a) {
                                    var row = _a.row;
                                    return row.activation_email_send_date &&
                                        (0, utilities_1.formatDate)({ date: row.activation_email_send_date });
                                },
                            },
                            {
                                label: 'Opciones',
                                align: 'right',
                                field: 'actions',
                                type: 'text',
                                valueGetter: function (_a) {
                                    var row = _a.row;
                                    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "row", justifyContent: "flex-end", spacing: "5px" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Tooltip, __assign({ title: "Ver tarjetas" }, { children: (0, jsx_runtime_1.jsx)(material_1.IconButton, __assign({ color: "default", onClick: function () { return handleShowClientCards(row); }, disabled: !DrawerCampaignAdminDetailContainer_1.showButtonClientCards.some(function (statusValid) { return statusValid === row.status; }) }, { children: (0, jsx_runtime_1.jsx)(icons_material_1.CreditCard, {}) })) })), (0, jsx_runtime_1.jsx)(material_1.Tooltip, __assign({ title: "Ver detalles" }, { children: (0, jsx_runtime_1.jsx)(material_1.IconButton, __assign({ color: "default", onClick: function () { return handleShowDetail(row); } }, { children: (0, jsx_runtime_1.jsx)(icons_material_1.Visibility, {}) })) }))] })));
                                },
                            },
                        ] }), (0, jsx_runtime_1.jsx)(TablePaginationComponent_1.default, { total: (campaignsData === null || campaignsData === void 0 ? void 0 : campaignsData.data) ? campaignsData === null || campaignsData === void 0 ? void 0 : campaignsData.metadata.pagination.total : 0 })] }), searchParams.get('campaignIdentifier') && ((0, jsx_runtime_1.jsx)(DrawerCampaignAdminDetailContainer_1.default, { open: disclosureCampaignDrawer.isOpen, onClose: handleCloseCampaignDrawer, onOpen: disclosureCampaignDrawer.onOpen })), disclosureCreateCampaignModal.isOpen && ((0, jsx_runtime_1.jsx)(ModalCreateCampaignContainer_1.default, { open: disclosureCreateCampaignModal.isOpen, onClose: disclosureCreateCampaignModal.onClose }))] }));
};
exports.default = CampaignList;
